var E = Object.defineProperty;
var x = (h, e, t) => e in h ? E(h, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : h[e] = t;
var g = (h, e, t) => x(h, typeof e != "symbol" ? e + "" : e, t);
const s = class s {
  /**
   * @param {Object} options The options to be used by the DomHelper instance.
   * @param {Node.ELEMENT_NODE} options.contextContainer The context container element to which this instance is bound to.
   * @param {String[]} options.ignoredElements An array of string selectors to ignore when capturing nodes with this helper.
   * @param {Object} options.nodeSelectors A data object to define the node selectors for the highlight data.
   *
   * @example
   * const contextEl = document.querySelector('main');
   *
   * const domHelper = new DomHelper({
   *   contextContainer: contextEl,
   *   ignoredElements: [
   *     'span',
   *     '.nebula-button',
   *   ],
   * });
   *
   * const targetEl = document.querySelector('.target-el');
   *
   * const arrTextNodes = domHelper.getAllTextNodes(targetEl);
   *
   * // Prints the captured array of text nodes.
   * console.log(arrTextNodes);
   */
  constructor(e) {
    g(this, "_clientId");
    g(this, "_contextContainer");
    g(this, "_ignoredElements");
    g(this, "_nodeSelectors");
    this._clientId = s.getNextClientId(), this.contextContainer = e == null ? void 0 : e.contextContainer, this.ignoredElements = e == null ? void 0 : e.ignoredElements, this.nodeSelectors = e == null ? void 0 : e.nodeSelectors;
  }
  /**
   * The unique client ID of this instance.
   * @type {Number}
   * @readonly
   *
   * @example
   * const domHelper = new DomHelper();
   *
   * // prints the client-id
   * console.log(domHelper.clientId);
   *
   * // throws an exception
   * domHelper.clientId = 123;
   */
  get clientId() {
    return this._clientId;
  }
  /**
   * The context-container to which this instance is bound to.
   * @type {Node.ELEMENT_NODE}
   */
  get contextContainer() {
    return this._contextContainer;
  }
  set contextContainer(e) {
    const t = e || document.body;
    if (!s.isElementNode(t)) {
      this.throwError('"contextContainer" should be an Element node-type.');
      return;
    }
    this._contextContainer = t;
  }
  /**
   * The immediate parent of context-container to which this instance is bound to.
   * @type {Node.ELEMENT_NODE}
   * @readonly
   */
  get contextContainerParent() {
    var e;
    return ((e = this.contextContainer) == null ? void 0 : e.parentNode) || null;
  }
  /**
   * The array of ignored element selectors.
   * @type {String[]}
   */
  get ignoredElements() {
    return this._ignoredElements;
  }
  set ignoredElements(e) {
    if (!e) {
      this._ignoredElements = [];
      return;
    }
    if (!Array.isArray(e)) {
      this._ignoredElements = [
        e
      ];
      return;
    }
    this._ignoredElements = e;
  }
  /**
   * The node selectors data object.
   * @type {NodeSelectorsData}
   */
  get nodeSelectors() {
    return this._nodeSelectors || (this._nodeSelectors = {
      primary: null,
      intermediate: null,
      target: null,
      selectorPostProcessor: null
    }), this._nodeSelectors;
  }
  set nodeSelectors(e) {
    this._nodeSelectors = {
      ...this._nodeSelectors,
      ...e
    };
  }
  /**
   * Finds the given node within the selectors provided.
   * @param {Node} node The node to find.
   * @param {String[]} selectors Array of selectors to match against. Higher priority selectors should be first.
   * @param {Boolean} [matchSameNode] Whether to consider the input node as a match, or strictly match child-nodes.
   * @param {Node.ELEMENT_NODE} [contextNode] The node within which to perform the search.
   * @returns {Object} Returns an object with `{ element: ..., selector: ... }` as data.
   */
  findNodeInSelectors(e, t, n = !1, r = null) {
    const i = {
      element: null,
      selector: null
    };
    if (!e || !t)
      return i;
    const o = r || this.contextContainer;
    return t.some((l) => ([...o.querySelectorAll(l)].some((a) => {
      if (this.isNodeInIgnoredList(a))
        return !1;
      const N = s.compareNodePosition(a, e);
      return N.isDescendant || n && N.isSameNode ? (i.element = a, i.selector = l, !0) : !1;
    }), !!i.element)), i;
  }
  /**
   * Get all the element nodes within a given node. If the node is
   * outside of the contextContainer OR if it is in the
   * ignored-elements list, skip them from processing.
   * @param {Node} node The node from which to extract the element nodes.
   * @returns {Array} An array of element-nodes for the given node.
   *
   * @example
   * const targetEl = document.querySelector('.target-el');
   *
   * domHelper.getAllElementNodes(targetEl);
   */
  getAllElementNodes(e) {
    let t = [];
    if (!this.isNodeInContextContainer(e) || this.isNodeInIgnoredList(e) || !s.isElementNode(e))
      return t;
    const n = [...e == null ? void 0 : e.children];
    return n.length && n.forEach((r) => {
      t.push(r), t = t.concat(
        this.getAllElementNodes(
          r
        )
      );
    }), t;
  }
  /**
   * Get all the text nodes within a given node. If the node is
   * outside of the contextContainer OR if it is in the
   * ignored-elements list, skip them from processing.
   * @param {Node} node The node from which to extract the text nodes.
   * @param {Boolean} [ignoreEmptyTextNodes] Ignore empty text nodes. These nodes will NOT be returned in the final list. Defaults to `true`.
   * @returns {Array} An array of text-nodes for the given node.
   *
   * @example
   * const targetEl = document.querySelector('.target-el');
   *
   * // returns all the text nodes except empty ones
   * domHelper.getAllTextNodes(targetEl);
   *
   * // returns all the text nodes including empty ones
   * domHelper.getAllTextNodes(targetEl, false);
   */
  getAllTextNodes(e, t = !0) {
    let n = [];
    if (!this.isNodeInContextContainer(e) || this.isNodeInIgnoredList(e))
      return n;
    if (s.isTextNode(e))
      return (e.textContent.trim().length || !t) && n.push(e), n;
    const { childNodes: r } = e;
    return r.length && r.forEach((i) => {
      n = n.concat(
        this.getAllTextNodes(
          i,
          t
        )
      );
    }), n;
  }
  /**
   * Get the common ancestor for the given nodes within the scope of the `contextContainer`.
   * @param {Node} node1 The first node.
   * @param {Node} node2 The second node.
   * @returns {Node} The common ancestor for the given nodes.
   */
  getCommonAncestor(e, t) {
    if (!s.isNode(e) || !s.isNode(t))
      return null;
    const { contextContainerParent: n } = this;
    let r = e.parentNode;
    for (; r && r !== n; ) {
      if (s.compareNodePosition(
        r,
        t
      ).isDescendant && !this.isNodeInIgnoredList(r))
        return r;
      r = r.parentNode;
    }
    return null;
  }
  /**
   * Gets the first text-node for the given node. If the given node is a text-node, returns itself.
   * @param {Node} node The node for which we need to grab the first text-node.
   * @returns {?Node.TEXT_NODE} Returns the first text-node it finds, otherwise returns `null`.
   */
  getFirstTextNode(e) {
    if (!this.isNodeInContextContainer(e) || this.isNodeInIgnoredList(e))
      return null;
    if (s.isTextNode(e))
      return e;
    const t = [...e.childNodes];
    if (!t.length)
      return null;
    const n = t.filter((i) => s.isElementOrTextNode(i) && !this.isNodeInIgnoredList(i));
    if (!n.length)
      return null;
    let r = null;
    return n.some((i) => (r = this.getFirstTextNode(i), !!r)), r;
  }
  /**
   * Grabs all the intermediate element-nodes for the given start and end nodes (excluding both).
   * @param {Node} startNode The start node.
   * @param {Node} endNode The end node.
   * @param {Node} [contextNode] The context-node to search for nodes. Only used internally for recursion.
   * @returns {Array} Returns an array of intermediate element nodes.
   */
  getIntermediateElementNodes(e, t, n = null) {
    if (!s.isNode(e) || !s.isNode(t))
      return [];
    if (e === t)
      return [];
    const r = s.compareNodePosition(
      e,
      t
    ).isPreceding, i = r ? t : e, o = r ? e : t;
    let l = [], d = !1, a = n || null;
    a || (a = s.getCommonAncestor(
      i,
      o
    ));
    const N = [...a.childNodes];
    return N.length && N.every((c) => {
      if (!d)
        return c === i ? (d = !0, !0) : (c.contains(i) && (l = l.concat(
          this.getIntermediateElementNodes(
            i,
            o,
            c
          )
        ), d = !0), !0);
      if (c === o)
        return !1;
      if (c.contains(o)) {
        const [u] = c.childNodes;
        if (u) {
          const { isDescendant: m } = s.compareNodePosition(
            o,
            u
          );
          u !== o && s.isElementNode(u) && !m && this.isNodeInContextContainer(u) && !this.isNodeInIgnoredList(u) && l.push(u);
        }
        return l = l.concat(
          this.getIntermediateElementNodes(
            u || c,
            o,
            c
          )
        ), !1;
      }
      return s.isElementNode(c) && l.push(c), l = l.concat(
        this.getAllElementNodes(
          c
        )
      ), !0;
    }), l;
  }
  /**
   * Grabs all the intermediate text-nodes for the given start and end nodes (excluding both).
   * @param {Node} startNode The start node.
   * @param {Node} endNode The end node.
   * @param {Node} [contextNode] The context-node to search for nodes. Only used internally for recursion.
   * @returns {Array} Returns an array of intermediate text nodes.
   */
  getIntermediateTextNodes(e, t, n = null) {
    if (!s.isNode(e) || !s.isNode(t))
      return [];
    if (e === t)
      return [];
    const r = s.compareNodePosition(
      e,
      t
    ).isPreceding, i = r ? t : e, o = r ? e : t;
    let l = [], d = !1, a = n || null;
    a || (a = s.getCommonAncestor(
      i,
      o
    ));
    const N = [...a.childNodes];
    return N.length && N.every((c) => {
      if (!d)
        return c === i ? (d = !0, !0) : (c.contains(i) && (l = l.concat(
          this.getIntermediateTextNodes(
            i,
            o,
            c
          )
        ), d = !0), !0);
      if (c === o)
        return !1;
      if (c.contains(o)) {
        const u = s.getFirstTextNode(c);
        if (u) {
          const { isDescendant: m } = s.compareNodePosition(
            o,
            u
          );
          u !== o && !m && this.isNodeInContextContainer(u) && !this.isNodeInIgnoredList(u) && l.push(u);
        }
        return l = l.concat(
          this.getIntermediateTextNodes(
            u || c,
            o,
            c
          )
        ), !1;
      }
      return l = l.concat(
        this.getAllTextNodes(
          c
        )
      ), !0;
    }), l;
  }
  /**
   * Gets the last text-node for the given node. If the given node is a text-node, returns itself.
   * @param {Node} node The node for which we need to grab the last text-node.
   * @returns {?Node.TEXT_NODE} Returns the first text-node it finds, otherwise returns `null`.
   */
  getLastTextNode(e) {
    if (!this.isNodeInContextContainer(e) || this.isNodeInIgnoredList(e))
      return null;
    if (s.isTextNode(e))
      return e;
    const t = [...e.childNodes];
    if (!t.length)
      return null;
    const n = t.findLast((r) => s.isElementOrTextNode(r) && !this.isNodeInIgnoredList(r));
    return n ? this.getLastTextNode(n) : null;
  }
  /**
   * Grabs the next sibling node. If one doesn't exist in the current parent,
   * it will continue searching for the next sibling in the next element tree.
   * @param {(Node.ELEMENT_NODE|Node.TEXT_NODE)} node The node for which we need the next sibling.
   * @returns {Node} Returns the next valid sibling.
   */
  getNextSibling(e) {
    if (!e)
      return null;
    const { nextSibling: t } = e;
    return !t || !this.isNodeInContextContainer(t) || this.isNodeInIgnoredList(t) ? this.getNextSibling(
      t || (e == null ? void 0 : e.parentElement)
    ) : t || null;
  }
  /**
   * Get a generic node selector.
   * @param {Node} node The node for which you need a selector.
   * @returns {?String} Returns a string selector if it matches the argument criteria, `null` otherwise.
   */
  getNodeSelector(e) {
    var l;
    let t = {
      primary: {
        element: null,
        selector: null
      },
      intermediate: {
        element: null,
        selector: null
      },
      target: {
        element: null,
        selector: null
      }
    };
    const { nodeSelectors: n } = this;
    if (!((l = n.primary) != null && l.length))
      return this.getStrictNodeSelector(
        e,
        n.selectorPostProcessor
      );
    if (t.primary = this.findNodeInSelectors(
      e,
      n.primary,
      !1
    ), !t.primary.element)
      return null;
    t.primary.selector += s.getNthChildString(
      t.primary.element
    );
    const r = n.intermediate || [];
    if (r.length) {
      if (t.intermediate = this.findNodeInSelectors(
        e,
        r,
        !1,
        t.primary.element
      ), !t.intermediate.element)
        return null;
      t.intermediate.selector += s.getNthChildString(
        t.intermediate.element
      );
    }
    const i = t.intermediate.element || t.primary.element;
    if (t.target = this.findNodeInSelectors(
      e,
      n.target,
      !0,
      i
    ), !t.target.element)
      return null;
    t.target.selector += s.getNthChildString(
      t.target.element
    ), typeof n.selectorPostProcessor == "function" && (t = n.selectorPostProcessor(e, t));
    let o = t.primary.selector.trim();
    return t.intermediate.selector && (o += " ", o += t.intermediate.selector.replace(/:scope/, "").trim()), o += " ", o += t.target.selector.replace(/:scope/, "").trim(), o;
  }
  /**
   * This method retrieves all the ancestor elements with an optional matching selector.
   * It's use here is to avoid depending on jQuery's `$.fn.parents`.
   * A conscious attempt is made to limit the matches within the contextContainer on the instance.
   * However, it is possible to skirt this check when the node is disconnected from contextContainer's
   * DOM tree.
   * @param {Node} node The node whose parents are to be retrieved.
   * @param {String} [selector] A string selector to match the parent elements.
   * @returns {Array} An array of parent nodes.
  */
  getParentElements(e, t = null) {
    const { contextContainerParent: n } = this, r = [];
    let i = e.parentElement;
    for (; i && i !== n; )
      this.isNodeInIgnoredList(i) || (!t || i.matches(t)) && r.push(i), i = i.parentElement;
    return r;
  }
  /**
   * Returns a strict CSS selector for the given node. Traversal stops at the `contextContainer`.
   * @param {Node} node The node for which a selector should be returned.
   * @param {Function} selectorPostProcessor The selector for the node can be post-processed using this function.
   * @param {String} selectorFragment The selector fragment that gets appended to during recursive operation.
   * @returns {String} The CSS selector.
   */
  getStrictNodeSelector(e, t = null, n = "") {
    var N, c;
    if (!e)
      return null;
    const { parentElement: r } = e;
    if (s.isTextNode(e))
      return this.getStrictNodeSelector(
        r,
        t
      );
    if (!s.isElementNode(e))
      return this.throwError("[getStrictNodeSelector] `node` should be either a Node.ELEMENT_NODE or Node.TEXT_NODE type."), null;
    const i = e;
    if (i === this.contextContainer) {
      if (i.id)
        return `#${i.id}>${n}`;
      const u = (N = this.contextContainer.nodeName) == null ? void 0 : N.toLowerCase(), m = Array.from(this.contextContainer.classList);
      return `${m.length ? `.${m.join(".")}` : u}>${n}`;
    }
    const o = (c = i.localName) == null ? void 0 : c.trim().toLowerCase(), l = [...r.children];
    let d = o;
    if (l.length > 1) {
      const u = l.indexOf(i) + 1;
      u > 1 && (d += `:nth-child(${u})`);
    }
    typeof t == "function" && (d = t(i, d));
    let a = n;
    return d && (a = n.length ? `${d}>${n}` : d), this.getStrictNodeSelector(
      r,
      t,
      a
    );
  }
  /**
   * Checks whether the given node belongs in this container context.
   * @param {Node} nodeToCheck The node to check.
   * @returns {Boolean} Returns `true` if yes, else returns `false`.
   */
  isNodeInContextContainer(e) {
    if (!e)
      return !1;
    if (e === this.contextContainer)
      return !0;
    const { isDescendant: t } = s.compareNodePosition(
      this.contextContainer,
      e
    );
    return t;
  }
  /**
   * Checks whether the given node is in the block list.
   * @param {Node} nodeToCheck The node to check.
   * @returns {Boolean} Returns `true` if yes, else returns `false`.
   */
  isNodeInIgnoredList(e) {
    const t = this.ignoredElements.join(",");
    return t ? this.isNodeInSelector(e, t) : !1;
  }
  /**
   * Checks whether the given node is within, or matches the given selector.
   * @param {Node} nodeToCheck Checks if this node is within the specified selector.
   * @param {Node} selector The selector(s) to check against.
   * @returns {Boolean} Returns `true` if `nodeToCheck` is within, or matches the given selector, `false` otherwise.
   */
  isNodeInSelector(e, t) {
    return e ? this.querySelectorAll(t).some((r) => {
      const i = s.compareNodePosition(r, e);
      return i.isDescendant || i.isSameNode;
    }) : !1;
  }
  /**
   * Grabs all nodes that match the selector AND also the `contextContainer` (if it matches).
   * @param {String} selector The string selector to match.
   * @returns {Array} An array of matched descendents of contextContainer, and contextContainer (if matched).
   */
  querySelectorAll(e) {
    var n;
    const t = Array.from(
      this.contextContainer.querySelectorAll(e)
    );
    return (n = this.contextContainer) != null && n.matches(e) ? [
      this.contextContainer,
      ...t
    ] : t;
  }
  /**
   * Throws an error with the specified error message along with helpful
   * context and timestamp details.
   * @param {String} message The error message to associate with the error.
   * @param {Object} [options] Optional options to pass into the Error constructor.
   */
  throwError(e, t = null) {
    const n = `[DomHelper][client-id=${this.clientId}] ${e}`, r = {
      context: this,
      ...t
    };
    return s.throwError(
      n,
      r
    );
  }
  /**
   * Checks the given node against an array of node types to check against.
   * This method exists to improve the readability of code in other methods.
   * @param {Node} node The node to check.
   * @param {Array} allowedNodeTypes An array of node types to check against. Elements can be Node.ELEMENT_NODE, Node.TEXT_NODE, etc.
   * @returns {Boolean} Returns `true` if the node matches any of the given node types.
   */
  static checkNodeType(e, t) {
    const n = (e == null ? void 0 : e.nodeType) || null;
    return t.includes(n);
  }
  /**
   * Returns an object with position related flags for easy consumption.
   * @param {Node} anchorNode The position will be compared against this node.
   * @param {Node} compareNode This is the node that will be used to compare against the `anchorNode`.
   * @returns {Object} An object with the position related flags.
   *                  {
   *                      isAncestor: {Boolean},
   *                      isDescendant: {Boolean},
   *                      isDisconnected: {Boolean},
   *                      isFollowing: {Boolean},
   *                      isPreceding: {Boolean},
   *                      isSameNode: {Boolean},
   *                      isUnreliable: {Boolean},
   *                  }
   */
  static compareNodePosition(e, t) {
    const n = {
      isAncestor: !1,
      isDescendant: !1,
      isDisconnected: !1,
      isFollowing: !1,
      isPreceding: !1,
      isSameNode: e === t,
      isUnreliable: !1
    };
    if (!e || !t)
      return n.isUnreliable = !0, n;
    const r = e.compareDocumentPosition(t);
    return n.isDisconnected = !!(r & Node.DOCUMENT_POSITION_DISCONNECTED), n.isPreceding = !!(r & Node.DOCUMENT_POSITION_PRECEDING), n.isFollowing = !!(r & Node.DOCUMENT_POSITION_FOLLOWING), n.isAncestor = !!(r & Node.DOCUMENT_POSITION_CONTAINS), n.isDescendant = !!(r & Node.DOCUMENT_POSITION_CONTAINED_BY), n.isUnreliable = !!(r & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC), n;
  }
  /**
   * Get all the element nodes within a given node.
   * @param {Node} node The node from which to extract the element nodes.
   * @returns {Array} An array of element-nodes for the given node.
   */
  static getAllElementNodes(e) {
    return new s().getAllElementNodes(
      e
    );
  }
  /**
   * Get all the text nodes within a given node.
   * @param {Node} node The node from which to extract the text nodes.
   * @param {Boolean} [ignoreEmptyTextNodes=true] Ignore empty text nodes. These nodes will NOT be returned in the final list. Defaults to `true`.
   * @returns {Array} An array of text-nodes for the given node.
   */
  static getAllTextNodes(e, t = !0) {
    return new s().getAllTextNodes(
      e,
      t
    );
  }
  /**
   * Get the common ancestor for the given nodes.
   * @param {Node} node1 The first node.
   * @param {Node} node2 The second node.
   * @returns {Node} The common ancestor for the given nodes.
   */
  static getCommonAncestor(e, t) {
    return new s().getCommonAncestor(e, t);
  }
  /**
   * Gets the first text-node for the given node. If the given node is a text-node, returns itself.
   * @param {Node} node The node for which we need to grab the first text-node.
   * @returns {?Node.TEXT_NODE} Returns the first text-node it finds, otherwise returns `null`.
   */
  static getFirstTextNode(e) {
    return new s().getFirstTextNode(e);
  }
  /**
   * Grabs all the intermediate element-nodes for the given start and end nodes (excluding both).
   * @param {Node} startNode The start node.
   * @param {Node} endNode The end node.
   * @param {Node} [contextNode] The context-node to search for nodes. Only used internally for recursion.
   * @returns {Array} Returns an array of intermediate element nodes.
   */
  static getIntermediateElementNodes(e, t, n = null) {
    return new s().getIntermediateElementNodes(
      e,
      t,
      n
    );
  }
  /**
   * Grabs all the intermediate text-nodes for the given start and end nodes (excluding both).
   * @param {Node} startNode The start node.
   * @param {Node} endNode The end node.
   * @param {Node} [contextNode] The context-node to search for nodes. Only used internally for recursion.
   * @returns {Array} Returns an array of intermediate text nodes.
   */
  static getIntermediateTextNodes(e, t, n = null) {
    return new s().getIntermediateTextNodes(
      e,
      t,
      n
    );
  }
  /**
   * Gets the last text-node for the given node. If the given node is a text-node, returns itself.
   * @param {Node} node The node for which we need to grab the last text-node.
   * @returns {?Node.TEXT_NODE} Returns the first text-node it finds, otherwise returns `null`.
   */
  static getLastTextNode(e) {
    return new s().getLastTextNode(e);
  }
  /**
   * Returns a unique numeric client-id for the current window and increments the _nextClientId counter by 1.
   * @returns {Number} A unique numeric client-id for the current window instance.
   */
  static getNextClientId() {
    const e = this._nextClientId;
    return this._nextClientId += 1, e;
  }
  /**
   * Grabs the next sibling node. If one doesn't exist in the current parent,
   * it will continue searching for the next sibling in the next element tree.
   * @param {(Node.ELEMENT_NODE|Node.TEXT_NODE)} node The node for which we need the next sibling.
   * @returns {Node} Returns the next valid sibling.
   */
  static getNextSibling(e) {
    return new s().getNextSibling(e);
  }
  /**
   * Get the CSS selector for the given node.
   * @param {Node} node The node for which you need a selector.
   * @param {Object} nodeSelectors The nodeSelectors object with mandatory and optional data needed to generate the selector.
   * @param {String[]} nodeSelectors.primary The primary selectors to use. Higher priority selectors need to be put earlier in the array.
   * @param {String[]} [nodeSelectors.intermediate=[]] The intermediate selectors to use. Higher priority selectors need to be put earlier.
   * @param {String[]} nodeSelectors.target The target selectors to use. Higher priority selectors need to be put earlier.
   * @param {Function} [nodeSelectors.selectorPostProcessor] A delegate to post-process the selector data prior to finalizing the value.
   * @returns {?String} Returns a string selector if it matches the argument criteria, `null` otherwise.
   */
  static getNodeSelector(e, t = {}) {
    return new s({
      nodeSelectors: {
        primary: (t == null ? void 0 : t.primary) || null,
        intermediate: (t == null ? void 0 : t.intermediate) || null,
        target: (t == null ? void 0 : t.target) || null,
        selectorPostProcessor: (t == null ? void 0 : t.selectorPostProcessor) || null
      }
    }).getNodeSelector(e);
  }
  /**
   * Get the nth-child number for the given node.
   * @param {Node} node The node for which the nth-child number is to be returned.
   * @returns {Number} The nth-child number for the given node.
   */
  static getNthChild(e) {
    let t = e;
    if (!this.isElementOrTextNode(e))
      return null;
    this.isTextNode(e) && (t = e.parentElement);
    const { parentNode: n } = t, r = [...n.children];
    let i = 1;
    return r.length > 1 && (i = r.indexOf(t) + 1), i;
  }
  /**
   * Get the nth-child string for the given node.
   * @param {Node} node The node for which the nth-child string is to be returned.
   * @returns {String} The nth-child string in the form of `':nth-child(n)'`, or a zero-length string `''`.
   */
  static getNthChildString(e) {
    const t = this.getNthChild(e);
    return t > 1 ? `:nth-child(${t})` : "";
  }
  /**
   * Get the offset of the text node in relation with the parent element.
   * @param {Node.TEXT_NODE} textNode The text-node for which we need the offset from the parent element.
   * @param {Node.ELEMENT_NODE} contextElement The ancestor element from which to calculate the offsets.
   * @param {Number} relativeOffset A relative offset by which the calculated offset will be adjusted. Can be positive or negative. Defaults to 0.
   * @returns {?Number} Returns `null` if the node is NOT a text-node or if it doesn't exist in the DOM.
   */
  static getOffsetForTextNode(e, t, n = 0) {
    if (!this.isTextNode(e) || !this.isNodeInDom(e) || !this.isElementNode(t) || !this.isNodeInDom(t))
      return null;
    let r = 0;
    return this.getAllTextNodes(t, !1).some((o) => o === e ? (r += n, !0) : (r += o.textContent.length, !1)), r;
  }
  /**
   * This method retrieves all the ancestor elements with an optional matching selector.
   * It's use here is to avoid depending on jQuery's `$.fn.parents`.
   * @param {Node} node The node whose parents are to be retrieved.
   * @param {String} [selector] A string selector to match the parent elements.
   * @returns {Array} An array of parent nodes.
  */
  static getParentElements(e, t = null) {
    return new s().getParentElements(e, t);
  }
  /**
   * Get the CSS selector for the given node.
   * @param {Node} node The node from which to calculate the selector.
   * @param {Function} selectorPostProcessor The selector for the node can be post-processed using this function.
   * @returns {String} The calculated selector for the given node.
   */
  static getStrictNodeSelector(e, t = null) {
    return new s().getStrictNodeSelector(e, t);
  }
  /**
   * Given a node and offset, gets the correct text node within it and returns the target and relative offset.
   * @param {Node} node The node to search within.
   * @param {Number} trueOffset The true offset to use for the search.
   * @param {Boolean} [preferNextNode] If set to `true` (default), will prefer to "spill over"
   *                                   to the next node when at the edge of the current node.
   *                                   If set to `false`, will prefer to stay within the confines
   *                                   of a given node.
   * @returns {Object} Returns an object with the `targetNode` and the relative `offset` as properties.
   */
  static getTextNodeFromOffset(e, t, n = !0) {
    let r = e, i = null, o = t;
    do
      i = this.getAllTextNodes(r, !1).find((d) => {
        const a = d.textContent.length;
        return o > a || n && o === a ? (o -= a, !1) : !0;
      }) || null, r = this.getNextSibling(r);
    while (i === null && r);
    return {
      targetNode: i,
      relativeOffset: o
    };
  }
  /**
   * Injects a given Element within targetNode at the provided offsets. If unspecified, it will use the start and end
   * of the given node.
   * @param {(Node.ELEMENT_NODE|Node.TEXT_NODE)} targetNode The node that we want to modify.
   * @param {Node.ELEMENT_NODE} injectionElement The element that we want to inject.
   * @param {Number} [startOffset] Optional start offset. Defaults to `0`.
   * @param {Number} [endOffset] Optional end offset. Defaults to end of string.
   */
  static injectElementInNode(e, t, n = null, r = null) {
    let i = null;
    if (this.isElementNode(e)) {
      i = e.outerHTML;
      const N = i.indexOf(">") + 1, c = i.lastIndexOf("</");
      n = n || 0, n += N, r === null ? r = c : r += N;
    } else if (this.isTextNode(e))
      i = e.textContent, n = n || 0, r = r || i.length;
    else {
      this.throwError("[injectElementInNode] Node needs to be an Element or a Text node.");
      return;
    }
    if (!i.trim().length)
      return;
    const o = i.substring(n, r);
    t.innerHTML = o;
    const l = t.outerHTML, d = i.substring(0, n), a = i.substring(r);
    i = `${d}${l}${a}`, this.replaceNodeWithContent(e, i);
  }
  /**
   * Injects a particular string within targetStr and the given index.
   * @param {String} targetStr The string where `injectionStr` will be injected into.
   * @param {String} injectionStr The string to inject.
   * @param {Number} injectionIndex The (zero-based) index where the string needs to be injected in `targetStr`.
   * @returns {String} The updated string.
   */
  static injectStringAtIndex(e, t, n) {
    const r = e.substring(0, n), i = e.substring(n);
    return `${r}${t}${i}`;
  }
  /**
   * Check whether a given node is an element-node.
   * @param {Node} node The node to check.
   * @returns {Boolean} Returns `true` if the node is an element-node.
   */
  static isElementNode(e) {
    return this.checkNodeType(
      e,
      [Node.ELEMENT_NODE]
    );
  }
  /**
   * Check whether a given node is either an element-node or a text-node.
   * @param {Node} node The node to check.
   * @returns {Boolean} Returns `true` if the node is either an element-node or a text-node.
   */
  static isElementOrTextNode(e) {
    return this.checkNodeType(
      e,
      [
        Node.ELEMENT_NODE,
        Node.TEXT_NODE
      ]
    );
  }
  /**
   * Checks whether the given parameter is an instance of node.
   * @param {Any} param The parameter to check.
   * @returns {Boolean} Returns `true` if the given parameter is an instance of Node.
   */
  static isNode(e) {
    return [
      Node.ELEMENT_NODE,
      Node.ATTRIBUTE_NODE,
      Node.TEXT_NODE,
      Node.CDATA_SECTION_NODE,
      Node.PROCESSING_INSTRUCTION_NODE,
      Node.COMMENT_NODE,
      Node.DOCUMENT_NODE,
      Node.DOCUMENT_TYPE_NODE,
      Node.DOCUMENT_FRAGMENT_NODE
    ].includes(e == null ? void 0 : e.nodeType);
  }
  /**
   * Checks whether the given node is present in the DOM.
   * @param {Node} node The node to check.
   * @returns {Boolean} Returns `true` if the node is in the DOM.
   */
  static isNodeInDom(e) {
    return e === document ? !0 : !!(e != null && e.parentNode);
  }
  /**
   * Checks if the node is visible in window
   */
  static isNodeVisible(e, t = 0) {
    const n = e.getBoundingClientRect();
    return n.top >= t && n.top < window.innerHeight && n.bottom > t && n.bottom <= window.innerHeight;
  }
  /**
   * Checks whether the given node is within, or matches the given selector.
   * @param {Node} nodeToCheck Checks if this node is within the specified selector.
   * @param {Node} selector The selector(s) to check against.
   * @returns {Boolean} Returns `true` if `nodeToCheck` is within, or matches the given selector, `false` otherwise.
   */
  static isNodeInSelector(e, t) {
    return new s().isNodeInSelector(
      e,
      t
    );
  }
  /**
   * Check whether a given node is a text-node.
   * @param {Node} node The node to check.
   * @returns {Boolean} Returns `true` if the node is a text-node.
   */
  static isTextNode(e) {
    return this.checkNodeType(
      e,
      [Node.TEXT_NODE]
    );
  }
  /**
   * Replace a node with a string representation of the HTML to replace with. Text fragments are supported.
   * @param {Node} targetNode The node to replace.
   * @param {String} replacementContent The HTML content to replace the node with.
   */
  static replaceNodeWithContent(e, t) {
    const { parentElement: n } = e, r = document.createRange().createContextualFragment(t);
    e.replaceWith(r), n.normalize();
  }
  /**
   * Throws an error with the specified error message along with helpful
   * context and timestamp details.
   * @param {String} message The error message to associate with the error.
   * @param {Object} [options] Optional options to pass into the Error constructor.
   */
  static throwError(e, t = null) {
    const n = `[DomHelper] ${e}`, r = {
      cause: {
        context: this,
        timestamp: /* @__PURE__ */ new Date(),
        ...t
      }
    };
    throw new Error(
      n,
      r
    );
  }
};
// +===================================+
// | Static implementation starts here |
// +===================================+
g(s, "_nextClientId", 1);
let f = s;
export {
  f as default
};
